import Swal from 'sweetalert2';
import { sendDeleteRequest, sendPostRequest } from './utils';
import { addAlert } from './alerts';

const reelectroPrompt = Swal.mixin({
    customClass: {
        container: 'modal',
        popup: 'modal__content',
        confirmButton: 'btn btn-submit btn-main-action outline',
        cancelButton:
            'btn btn-secondary btn-secondary-action outline border-white mr-20',
    },
    buttonsStyling: false,
    backdrop: 'rgba(184, 211, 198, 0.8)',
});
export async function prompt({
    title = gettext('Potwierdź akcję'),
    text = '',
    html = '',
    confirmText = gettext('Potwierdź'),
    cancelText = gettext('Anuluj'),
    input = undefined,
    inputOptions = undefined,
    inputValue = undefined,
    inputLabel = undefined,
    confirmAction = () => {},
    cancelAction = () => {},
} = {}) {
    const action = await reelectroPrompt.fire({
        title: title,
        text: text,
        html: html,
        width: 600,
        padding: '4rem 2rem',
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        reverseButtons: true,
        input: input,
        inputOptions: inputOptions,
        inputValue: inputValue,
        inputLabel: inputLabel,
    });
    if (action.isConfirmed) {
        confirmAction(action);
    } else {
        cancelAction(action);
    }
    return action;
}
export function requestPrompt({
    options = {},
    method = null,
    url = null,
    data = null,
    successAction = function (response) {
        if (response?.data?.message) addAlert('success', response.data.message);
    },
    failedAction = function (response) {
        if (response?.data?.message) addAlert('error', response.data.message);
    },
}) {
    prompt({
        ...options,
        confirmAction: async function () {
            let func = null;
            switch (method) {
                case 'delete':
                    func = sendDeleteRequest;
                    break;
                case 'post':
                    func = sendPostRequest;
                    break;
                default:
                    return;
            }
            try {
                const response = await func(url, data);
                if (response.status === 200) {
                    const responseData = await response
                        .json()
                        .catch(() => ({}));
                    successAction({
                        status: response.status,
                        data: responseData,
                    });
                } else {
                    const responseData = await response
                        .json()
                        .catch(() => ({}));
                    failedAction({
                        status: response.status,
                        data: responseData,
                    });
                }
            } catch (error) {
                failedAction(error?.response || error);
            }
        },
    });
}

export function deletePrompt({
    options = undefined,
    url = undefined,
    data = undefined,
    successAction = undefined,
    failedAction = undefined,
}) {
    requestPrompt({
        options: options,
        method: 'delete',
        url: url,
        data: data,
        successAction: successAction,
        failedAction: failedAction,
    });
}

export function postPrompt({
    options = undefined,
    url = undefined,
    data = undefined,
    successAction = undefined,
    failedAction = undefined,
}) {
    requestPrompt({
        options: options,
        method: 'post',
        url: url,
        data: data,
        successAction: successAction,
        failedAction: failedAction,
    });
}

export default {
    prompt,
    deletePrompt,
    postPrompt,
};
